export { type Country, type CountryWithLanguages, NEXT_APP_CONFIG } from "@/i18n/apps"

import { isPreviewLocale, NEXT_APP_CONFIG, type CountryWithLanguages } from "@/i18n/apps"

/**
 * Every country and locale a visitor may pick — the source for the site selector and the
 * header country picker.
 *
 * Preview locales are filtered out, and a country whose every locale is still preview
 * drops out entirely: an unfinished site must not be linkable from a live page.
 */
export const getAllCountriesAndPaths = (): CountryWithLanguages[] =>
    NEXT_APP_CONFIG.flatMap(country => {
        const languages = country.languages.filter(
            language => !isPreviewLocale(language.path)
        )

        return languages.length > 0 ? [{ ...country, languages }] : []
    })
